const ELIGIBLE_REASON_CODE = 'Eligible'

export const notEligibleUiLabelsByCode = {
  NoSubscriptionNoPhone: 'No phone number',
  NoSubscriptionWithPhone: 'Sync pending',
  UnsupportedCountry: 'Unsupported country',
  SyncPending: 'Sync pending',
  OptedOut: 'Opted out',
  BrandExcluded: 'Excluded',
  Inactive: 'Excluded',
  NoAccountPhone: 'No phone number',
  InvalidPhone: 'Invalid phone number',
  PhoneEnrichmentIncomplete: 'No phone number'
}

const uiLabelDisplayOrder = [
  'No phone number',
  'Unsupported country',
  'Sync pending',
  'Opted out',
  'Excluded',
  'Invalid phone number'
]

export function getUiLabelForReason(reason) {
  const code = reason?.code ?? reason?.Code
  if (code && notEligibleUiLabelsByCode[code]) {
    return notEligibleUiLabelsByCode[code]
  }

  return reason?.label ?? reason?.Label ?? code
}

export function getNotEligibleReasons(reasonsData) {
  const reasons = reasonsData?.reasons ?? reasonsData?.Reasons ?? []
  const countsByLabel = {}

  reasons.forEach(reason => {
    const code = reason?.code ?? reason?.Code
    if (!code || code === ELIGIBLE_REASON_CODE) {
      return
    }

    const label = getUiLabelForReason(reason)
    const count = reason.count ?? reason.Count ?? 0
    countsByLabel[label] = (countsByLabel[label] || 0) + count
  })

  const orderedLabels = [
    ...uiLabelDisplayOrder.filter(label => countsByLabel[label] > 0),
    ...Object.keys(countsByLabel).filter(label => !uiLabelDisplayOrder.includes(label))
  ]

  return orderedLabels.map(label => ({
    code: label,
    label,
    count: countsByLabel[label]
  }))
}

export function getNotEligibleCount(reasonsData) {
  if (reasonsData == null) {
    return 0
  }

  if (reasonsData.notEligible != null) {
    return reasonsData.notEligible
  }

  if (reasonsData.NotEligible != null) {
    return reasonsData.NotEligible
  }

  return getNotEligibleReasons(reasonsData).reduce((sum, reason) => {
    return sum + (reason.count ?? reason.Count ?? 0)
  }, 0)
}
